// extracted by mini-css-extract-plugin
module.exports = {"leapLife":"_33hTtCknE29jJb_PLHskCb","logo":"suAxMzBFeo5bL1tP-oc8-","info":"MAHxBiwV2TnZc8eCvhdSH"};